import { DATE_TIME_YMD, DATE_YMD } from '@shared/components/constants/common.constants';
import moment from 'moment';

interface formatDateTimeOptions {
    returnDefault?: string | null,
    onlyTime?: boolean,
    currentformat?: string,
    useLocalTime?: boolean,
    useServerTime?: boolean
}

export const formatDateTime = (
    datetime?: string | Date | null,
    format?: string,
    options?: formatDateTimeOptions
) => {
    if (!datetime) return options?.returnDefault ?? null;

    const useLocalTime = options?.useLocalTime ?? true;
    const addJstOffset = (m: moment.Moment) => m.clone().add(options?.useServerTime ? 0 : 9, 'hours'); // UTC + 9h

    if (options?.onlyTime && options?.currentformat) {
        const parsed = moment(datetime, [moment.ISO_8601, options.currentformat]);
        return useLocalTime ?
            parsed.format(format) :
            addJstOffset(parsed.utc()).format(format);
    }

    if (datetime instanceof Date) {
        const parsed = moment(datetime);
        return useLocalTime ?
            parsed.format(format) :
            addJstOffset(parsed.utc()).format(format);
    }

    const parsed = moment(datetime);

    return useLocalTime ?
        parsed.format(format) :
        addJstOffset(parsed.utc()).format(format);
};

export const formatDisplayDateTime = (date?: Date, time?: string | null, dateFormat: string = DATE_TIME_YMD) => {
    if (!date) return '';

    const timeToUse = time || '00:00';

    const formattedDate = formatDateTime(date, DATE_YMD);
    const [hours, minutes] = timeToUse.split(':');

    const dateTimeString = `${formattedDate} ${hours}:${minutes}`;

    return formatDateTime(dateTimeString, dateFormat);
};
